import {ApplicationConfig, ErrorHandler, provideZoneChangeDetection} from '@angular/core';
import { provideRouter } from '@angular/router';

import { routes } from './app.routes';
import { provideHttpClient, withInterceptors } from "@angular/common/http";
import { errorHandlerInterceptor } from "@utils/interceptor/http-error.interceptor";
import {newRelicInterceptor} from './domain/payment-domain/interceptors/newrelic.interceptor';
import {GlobalErrorHandler} from './domain/payment-domain/services/error-handler.service';
import {NewRelicService} from './domain/payment-domain/services/newRelic.service';


export const appConfig: ApplicationConfig = {
  providers: [
    provideZoneChangeDetection({ eventCoalescing: true }),
    provideRouter(routes),
    provideHttpClient(
      withInterceptors([errorHandlerInterceptor])
    ),
    NewRelicService,
    {
      provide: ErrorHandler,
      useClass: GlobalErrorHandler
    },
    provideHttpClient(
      withInterceptors([newRelicInterceptor])
    ),
  ]
};
